<nav id="product-navbar-container">
    <div id="product-navbar-general-container">
        <span>
            <a (click)="goToMain()">{{title()}}</a>
        </span>
        @if (shouldShowSpecs()) {
            <ul>
                <li><a (click)="goToSpecs()">Especificaciones</a></li>
            </ul>
        }

    </div>
</nav>
